import React from "react";
import CheckoutButton from "components/checkout-button";
import CartSummary from "./summary";
import DeliveryFrequencies from "components/delivery-frequencies";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/global";

const CartFooter = ({ isSticky }) => {
	const { checkoutLoading } = useSelector(state => state.cart);
	const { isOneTimeCollection } = useGlobalContext();

	return(
		<div className="z-10 px-7 pb-3 bg-white">
			<CartSummary isSticky={isSticky} />
			<div className="lg:mx-2 variant-B-cart">
				{!checkoutLoading && !isOneTimeCollection && <DeliveryFrequencies hideFrequencies={[8]} dropdown className="md:!w-full variant-B-dropdown"/>}
				<CheckoutButton />
			</div>
		</div >
	);
};

export default CartFooter;